var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.377,
    height: 16.401,
    viewBox: "0 0 16.377 16.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call_1_",
    "data-name": "phone-call (1)",
    transform: "translate(-0.145 0.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17450",
    "data-name": "Group 17450",
    transform: "translate(0.344 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19175",
    "data-name": "Path 19175",
    d: "M12.887,36.33a1.562,1.562,0,0,0-1.133-.52,1.615,1.615,0,0,0-1.147.516L9.548,37.383c-.087-.047-.174-.091-.258-.134-.121-.06-.235-.117-.332-.178A11.516,11.516,0,0,1,6.2,34.556a6.8,6.8,0,0,1-.905-1.429c.275-.252.53-.513.778-.765.094-.094.188-.191.282-.285a1.539,1.539,0,0,0,0-2.321l-.915-.916c-.1-.1-.211-.211-.312-.319-.2-.208-.412-.423-.63-.624a1.587,1.587,0,0,0-1.123-.493,1.642,1.642,0,0,0-1.14.493l-.007.007-1.14,1.15a2.454,2.454,0,0,0-.727,1.559A5.881,5.881,0,0,0,.787,33.1a14.441,14.441,0,0,0,2.565,4.279A15.778,15.778,0,0,0,8.605,41.5a8.183,8.183,0,0,0,2.95.872c.07,0,.144.007.211.007a2.526,2.526,0,0,0,1.934-.832c0-.007.01-.01.013-.017a7.624,7.624,0,0,1,.587-.607c.144-.138.292-.282.436-.433a1.673,1.673,0,0,0,.506-1.16,1.612,1.612,0,0,0-.516-1.15Zm1.2,3.531s0,0,0,0c-.131.141-.265.268-.409.409a8.817,8.817,0,0,0-.647.671,1.616,1.616,0,0,1-1.261.533c-.05,0-.1,0-.154,0A7.269,7.269,0,0,1,9,40.687,14.893,14.893,0,0,1,4.053,36.81a13.617,13.617,0,0,1-2.414-4.021,4.79,4.79,0,0,1-.375-2.1,1.54,1.54,0,0,1,.463-1L2.869,28.55a.762.762,0,0,1,.51-.238.717.717,0,0,1,.489.235l.01.01c.2.191.4.389.6.6.1.107.211.215.318.325l.915.916a.64.64,0,0,1,0,1.04c-.1.1-.191.195-.288.288-.282.288-.55.557-.841.818-.007.007-.013.01-.017.017a.684.684,0,0,0-.174.761l.01.03A7.351,7.351,0,0,0,5.488,35.12l0,0a12.306,12.306,0,0,0,2.977,2.71,4.576,4.576,0,0,0,.412.225c.121.06.235.117.332.178.013.007.027.017.04.023a.727.727,0,0,0,.332.084.717.717,0,0,0,.51-.231l1.147-1.147a.758.758,0,0,1,.506-.252.683.683,0,0,1,.483.245l.007.007,1.847,1.848A.663.663,0,0,1,14.087,39.862Z",
    transform: "translate(-0.344 -26.377)",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19176",
    "data-name": "Path 19176",
    d: "M245.361,86.931a4.832,4.832,0,0,1,3.935,3.935.5.5,0,0,0,.5.421.672.672,0,0,0,.086-.008.507.507,0,0,0,.417-.586,5.843,5.843,0,0,0-4.761-4.761.509.509,0,0,0-.586.413A.5.5,0,0,0,245.361,86.931Z",
    transform: "translate(-237.083 -83.164)",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19177",
    "data-name": "Path 19177",
    d: "M257.2,7.847A9.621,9.621,0,0,0,249.364.008a.506.506,0,1,0-.165,1A8.593,8.593,0,0,1,256.2,8.012a.5.5,0,0,0,.5.42.67.67,0,0,0,.086-.008A.5.5,0,0,0,257.2,7.847Z",
    transform: "translate(-241.234 0)",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.8525b3fe7c1bd1a9ae0c20db1505841c.svg";
export { ForwardRef as ReactComponent };